module.exports = __tmimport("~load:{controller: \'data\', action: \'territories\'}");